const UPDATES = [
  {
    date: '2026.08.01',
    title: '夏季剧场专题重磅上线',
    desc: '多部独家引进国产剧集和院线新片同步热映，涵盖都市情感、古装玄幻、悬疑推理等热门题材。',
  },
  {
    date: '2026.07.28',
    title: '4K蓝光专区全面升级',
    desc: '新增200+部超清蓝光影视资源，优化HDR色彩表现，大屏TV版画质体验再提升。',
  },
  {
    date: '2026.07.22',
    title: '动漫新番暑期档同步开播',
    desc: '《鬼灭之刃》《咒术回战》等20+部热门日漫新番与日本同步更新，国漫专区同步上新。',
  },
  {
    date: '2026.07.15',
    title: '多线路播放引擎优化完成',
    desc: '全面升级CDN加速节点，高峰期播放流畅度提升40%，真正实现不缓冲秒播体验。',
  },
  {
    date: '2026.07.08',
    title: '综艺频道改版上线',
    desc: '新增热门综艺分类导航，涵盖真人秀、脱口秀、音乐竞技、选秀节目等，整理更清晰。',
  },
  {
    date: '2026.06.30',
    title: '电影大全突破5万部',
    desc: '平台院线大片资源库持续扩充，涵盖国内外经典电影、独立佳片和高分纪录片。',
  },
  {
    date: '2026.06.20',
    title: '少儿模式正式推出',
    desc: '专为小朋友设计的少儿频道上线，内容经过严格筛选，支持家长控制观看时长。',
  },
  {
    date: '2026.06.10',
    title: '夜间模式与播放记忆功能上线',
    desc: '新增深色护眼夜间模式，看剧更舒适；播放进度自动记忆，换设备也能继续观看。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            天美麻花星空影视平台更新与内容上线快讯
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-3 md:left-4 top-2 bottom-2 w-px bg-background-300/30"></div>
            <div className="space-y-6 md:space-y-8">
              {UPDATES.map((item, idx) => (
                <div key={idx} className="relative">
                  <div className="absolute -left-[26px] md:-left-[30px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100"></div>
                  <div className="text-xs text-primary-400 font-medium mb-1">
                    {item.date}
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}